export default {
    ConfiguracaoDeCredenciamento: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "configuracao-de-credenciamento"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ConfiguracaoDeCredenciamento.js
// module id = CbXp
// module chunks = 18